"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _a, _b, _c, _d, _e;
"use strict";
const moment_1 = __importDefault(require("moment"));
const _1 = require(".");
const __1 = require("..");
const Command_1 = require("../Command");
const helpers_1 = require("../helpers");
const ObjectModel_1 = require("../ObjectModel");
class OMIdentity extends __1.OMObject {
    constructor(object) {
        super(object);
        this.identityType = object.identityType;
        this.provider = object.provider;
        this.identifier = object.identifier;
        this.challenge = object.challenge;
        this.resetCode = object.resetCode;
        this.verificationCode = object.verificationCode;
        this.activatedAt = object.activatedAt && moment_1.default(object.activatedAt);
        this.verifiedAt = object.verifiedAt && moment_1.default(object.verifiedAt);
        this.user = object.user && new ObjectModel_1.OMReference(_1.OMUser, object.user);
    }
    static FromJson(object) {
        return new OMIdentity(object);
    }
    resetChallenge() {
        try {
            const command = new OMIdentity.ResetChallengeCommand(this);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    requestReset() {
        try {
            const command = new OMIdentity.RequestResetCommand(this);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    verify() {
        try {
            const command = new OMIdentity.VerifyCommand(this);
            return Command_1.CommandManager.shared.addToQueue(command)
                .then((response) => __1.OMUniverse.shared.apiClient.objectsFromResponse(_1.OMSession, response.data))
                .then((sessions) => sessions[0])
                .then((session) => {
                __1.OMUniverse.shared.setSession(session);
                const user = session.user.actualObject;
                __1.OMUniverse.shared.setUser(user);
                if (__1.OMUniverse.shared.user.identities) {
                    __1.OMUniverse.shared.identities = __1.OMUniverse.shared.user.identities
                        .map((identityRef) => identityRef.actualObject)
                        .map((id) => new OMIdentity(id));
                    __1.OMUniverse.shared.identities.forEach((id) => __1.OMUniverse.shared.touch(id, true));
                }
                if (__1.OMUniverse.shared.user.groups) {
                    __1.OMUniverse.shared.touch(__1.OMUniverse.shared.user.groups.map((group) => group.actualObject), true);
                }
            });
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    requestVerificationCode() {
        try {
            const command = new OMIdentity.RequestVerificationCodeCommand(this);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    updateChallenge(newChallenge) {
        try {
            const command = new OMIdentity.UpdateChallengeCommand(this, newChallenge);
            return Command_1.CommandManager.shared.addToQueue(command);
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
}
OMIdentity.Path = "identities";
OMIdentity.Type = "identity";
OMIdentity.ResetChallengeCommand = (_a = class ResetChallengeCommand extends Command_1.Command {
        constructor(receiver) {
            super(receiver);
            this.resetCode = receiver.resetCode || "";
            this.challenge = receiver.challenge || "";
        }
        execute() {
            return __1.OMUniverse.shared.apiClient.send({
                data: helpers_1.JsonUtils.toJsonApi(this),
                method: "POST",
                // tslint:disable-next-line:max-line-length
                url: `${this.typeClass.Path}/${this.receiver.actualObject.identifier}/${ResetChallengeCommand.Path}`,
            });
        }
    },
    _a.Path = "reset_challenge",
    _a);
OMIdentity.VerifyCommand = (_b = class VerifyCommand extends Command_1.Command {
        constructor(receiver) {
            super(receiver);
            this.verificationCode = receiver.verificationCode || "";
        }
        execute() {
            return __1.OMUniverse.shared.apiClient.send({
                data: helpers_1.JsonUtils.toJsonApi(this),
                method: "POST",
                // tslint:disable-next-line:max-line-length
                url: `${this.typeClass.Path}/${this.receiver.actualObject.identifier}/${VerifyCommand.Path}`,
            });
        }
    },
    _b.Path = "verify",
    _b);
OMIdentity.RequestResetCommand = (_c = class RequestResetCommand extends Command_1.Command {
        constructor(receiver) {
            super(receiver);
            this.identifier = receiver.identifier;
        }
        execute() {
            return __1.OMUniverse.shared.apiClient.send({
                data: helpers_1.JsonUtils.toJsonApi(this),
                method: "POST",
                // tslint:disable-next-line:max-line-length
                url: `${this.typeClass.Path}/${this.receiver.actualObject.identifier}/${RequestResetCommand.Path}`,
            });
        }
    },
    _c.Path = "request_reset",
    _c);
OMIdentity.RequestVerificationCodeCommand = (_d = class RequestVerificationCodeCommand extends Command_1.Command {
        constructor(receiver) {
            super(receiver);
        }
        execute() {
            return __1.OMUniverse.shared.apiClient.send({
                data: helpers_1.JsonUtils.toJsonApi(this),
                method: "POST",
                // tslint:disable-next-line:max-line-length
                url: `${this.typeClass.Path}/${this.receiver.actualObject.identifier}/${RequestVerificationCodeCommand.Path}`,
            });
        }
    },
    _d.Path = "request_verification_code",
    _d);
OMIdentity.UpdateChallengeCommand = (_e = class UpdateChallengeCommand extends Command_1.Command {
        constructor(receiver, newChallenge) {
            super(receiver);
            this.currentChallenge = receiver.challenge || "";
            this.newChallenge = newChallenge;
        }
    },
    _e.Path = "update_challenge",
    _e);
exports.default = OMIdentity;
//# sourceMappingURL=OMIdentity.js.map